import isFunction from 'lodash/isFunction';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import { useEffect, useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import styles from './Drawer.module.scss';

const Drawer = ({
  active = false,
  handleClose,
  crossSale = null,
  position = 'right',
  product,
  children,
  closeButton = null,
  className = '',
  contentClassName = '',
  isSlim = false,
  isWide = false,
  fullHeight = false,
}) => {
  const [isBrowser, setIsBrowser] = useState(false);

  const contentRef = useRef(null);
  const contentSliderRef = useRef(null);
  const drawerRef = useRef(null);

  // create drawer wrapper element
  useEffect(() => {
    const drawerElement = document.getElementById('g-drawer');
    if (!drawerElement) {
      var element = document.createElement('div');
      element.id = 'g-drawer';
      document.body.appendChild(element);
    }
    setIsBrowser(true);
  }, []);

  // no scroll body if drawer is open
  useEffect(() => {
    const body = document.getElementsByTagName('body')[0];
    if (active) {
      body.classList.add('noScroll');
    } else {
      body.classList.remove('noScroll');
    }

    const header = document.getElementById('site-header');
    if (contentSliderRef && contentSliderRef.current) {
      contentSliderRef.current.style.height = `calc(100vh - ${header?.clientHeight}px)`;
      contentSliderRef.current.style.top = `${header?.clientHeight}px`;
    }

    return () => {
      body.classList.remove('noScroll');
    };
  }, [active]);

  // close on outside click
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [contentRef, active]);

  const handleClickOutside = e => {
    if (
      active &&
      contentRef &&
      !contentRef.current.contains(e.target) &&
      isFunction(handleClose)
    ) {
      handleClose();
    }
  };

  if (isBrowser && active) {
    return createPortal(
      <div
        ref={drawerRef}
        className={`${styles?.drawer} ${styles[position]} ${
          active ? styles?.active : ''
        } ${className} ${isSlim ? styles.isSlim : ''}
        ${isWide ? styles.isWide : ''}`}
      >
        <div className="relative h-full">
          {closeButton}
          <div
            ref={contentRef}
            className={`${styles?.content} ${contentClassName} ${
              fullHeight ? styles.fullHeight : ''
            }`}
          >
            {children}
          </div>
        </div>
      </div>,
      document.getElementById('g-drawer'),
    );
  }

  return null;
};

export default Drawer;
